import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser'
import { AuthService } from '@app/services/auth.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css']
})
export class NewUserComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @ViewChild('idTemplate', { static: true }) idTemplate!: TemplateRef<any>;
  @ViewChild('createdTemplate', { static: true }) createdTemplate!: TemplateRef<any>;
  @ViewChild('assignTabTemplate', { static: true }) assignTabTemplate!: TemplateRef<any>;
  @ViewChild('actionTemplate', { static: true }) actionTemplate!: TemplateRef<any>;
  columns: any[]=[
    {prop:'_id', name:'Index',cellTemplate: this.idTemplate},
    {prop:'contactPersonName', name:'Person Name'},
    {prop:'email', name:'Email'},
    {prop:'phone', name:'Phone'},
    {prop:'position', name:'Role'},
    {prop:'assignedTable', name:'Assign Table',cellTemplate: this.assignTabTemplate},
    {prop:'created', name:'Created At',cellTemplate: this.createdTemplate},
    {prop:'action', name:'Action',cellTemplate: this.actionTemplate},
  ];
  rows: any[] = [];
  searchText:any='';
  filterList:any=[];
  timeout: any;
  columnMode: ColumnMode = ColumnMode.force;
  rowHeight: 'auto' | number = 'auto'
  formGroup: UntypedFormGroup;
  usersList:any[]=[];
  isEdit:boolean=false;
  isPlaceholderFixed:boolean = false;
  imageUrl: SafeUrl ='/assets/images/avatars/thumb-1.jpg';
  roles = [
        {
            name: 'Admin',
            value: 'Admin'
        },
        {
            name: 'Employee',
            value: 'Employee'
        },
    ]
  clientName:any=this.auth.getClientName();
  constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private cdr: ChangeDetectorRef, private toastr: ToastrService) { }
  
  ngOnInit(): void {
    this.getUsers();
    this.formGroup = this.formBuilder.group({
        _id:[''],
        contactPersonName: ['', Validators.required],
        email: ['', [
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
        ]],
        phone: ['', Validators.pattern(/(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/)],
        position: [, Validators.required]
    });
  }
  getUsers(){
    this.auth.getUsers().subscribe((res:any)=>{
      this.usersList = res;
      this.rows = res
      this.filterList = res;
      this.cdr.detectChanges();
      // console.log(this.usersList)
    },(err:any)=>{
      console.log(err);
    })
  }

  onPage(event:any) {
      clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
          // console.log('paged!', event);
      }, 100);
  }


  onSubmit() {
    // console.log(this.formGroup.value);
    if(this.formGroup.controls['_id'].value != '' &&  this.formGroup.controls['_id'].value != null)
    {
      this.auth.updateUserData(this.formGroup.value).subscribe((res:any)=>{
        this.getUsers();
        this.formGroup.reset();
        this.toastr.success(res.message);
        this.isEdit = false;
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
      })
    }
    else
    {
      this.auth.addUser(this.formGroup.value).subscribe((res:any)=>{
        this.getUsers();
        this.formGroup.reset()
        this.toastr.success(res.message);
        this.isEdit = false;
      },(err:any)=>{
        console.log(err);
        this.toastr.error(err.message);
      })
    }
  }
  editUser(data:any){
    this.isEdit = true;
    this.formGroup.patchValue(data);
  }
  deleteUser(id:any){
    this.auth.deleteUser(id).subscribe((res:any)=>{
      this.getUsers()
      this.toastr.success(res.message);
    },(err:any)=>{
      console.log(err);
      this.toastr.error(err.message);
    })
  }
  changePassword(id:any){
    this.auth.changePassword(id).subscribe((res:any)=>{
      this.getUsers()
      this.toastr.success(res.message);
    },(err:any)=>{
      console.log(err);
      this.toastr.error(err.message);
    })
  }
  filteredUsers() {
    this.filterList = this.usersList.filter((user:any) =>
      user.contactPersonName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      user.email.toLowerCase().includes(this.searchText.toLowerCase())
    );
    setTimeout(() => {
      this.rows = this.filterList;
      this.cdr.detectChanges();
    }, 300);
  }
  removePrefix(value:any){
    if(value.length>0)
    {
      var datalist ='';
      value.forEach((element:any) => {
        console.log(element)
        datalist +=   element.startsWith(this.clientName) ? element.replace(this.clientName, '').replace(/_/g, ' ').trim() : element.trim()
        datalist +=', '
      });
      return datalist;
    }
    else
      return '-';
  }

}
